import { render } from "./addHandWorkModel.vue?vue&type=template&id=150dd487"
import script from "./addHandWorkModel.vue?vue&type=script&lang=js"
export * from "./addHandWorkModel.vue?vue&type=script&lang=js"

import "./addHandWorkModel.vue?vue&type=style&index=0&id=150dd487&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__